import { Component, Input, OnInit } from "@angular/core";
import { Vulnerability } from "../../interfaces/vulnerability";
import {
  PoTableColumn,
  PoTableColumnLabel,
  PoTableColumnSort,
} from "@po-ui/ng-components";
import { Severity } from "../../enums/severity";
import { DependencyTrackTableSortService } from "../../services/dependency-track-table-sort/dependency-track-table-sort.service";
import { DependencyTrackVulnerabilityDetails } from "../../interfaces/dependency-track-vulnerability-details";

@Component({
  selector: "app-dependency-track-vulnerabilities-table",
  templateUrl: "./dependency-track-vulnerabilities-table.component.html",
  styleUrls: ["./dependency-track-vulnerabilities-table.component.css"],
})
export class DependencyTrackVulnerabilitiesTableComponent implements OnInit {
  @Input() items: DependencyTrackVulnerabilityDetails;

  columns: Array<PoTableColumn> = [];
  loading: boolean = false;

  constructor(
    private dependencyTrackTableSortService: DependencyTrackTableSortService
  ) {}

  ngOnInit(): void {
    this.setVulnerabilitiesColumns();
  }

  onSort(columnSort: PoTableColumnSort): void {
    this.items = this.dependencyTrackTableSortService.sort(
      this.items,
      columnSort
    );
  }

  private setVulnerabilitiesColumns(): void {
    const severityLabels: Array<PoTableColumnLabel> = [
      { value: "CRITICAL", color: "color-07", label: "Crítica" },
      { value: "HIGH", color: "color-08", label: "Alta" },
      { value: "MEDIUM", color: "color-09", label: "Média" },
      { value: "LOW", color: "color-10", label: "Baixa" },
      { value: "INFO", color: "color-11", label: "Info" },
      { value: "UNASSIGNED", color: "color-02", label: "Não Atribuída" },
    ];

    this.columns = [
      { property: "vulnerability", label: "Vulnerabilidade", type: "string" },
      { property: "name", label: "Nome", type: "string" },
      {
        property: "severity",
        label: "Severidade",
        type: "label",
        labels: severityLabels,
      },
      { property: "dependency", label: "Dependência", type: "string" },
      { property: "version", label: "Versão", type: "string" },
      { property: "lastVersion", label: "Última versão", type: "string" },
      {
        property: "classifiedBy",
        label: "Classificado por",
        type: "string",
        visible: false,
      },
      {
        property: "classifiedOn",
        label: "Classificado em",
        type: "date",
        format: "dd/MM/yyyy",
        visible: false,
      },
    ];
  }
}
